import React from 'react'
import { connect } from 'react-redux'
import Col from 'muicss/lib/react/col'
import Row from 'muicss/lib/react/row'
import { selectCampaign } from '../../actions'
import EarnedForWinning from './EarnedForWinning'
import SummaryMission from './SummaryMission'

class MissionFinish extends React.Component {

  render() {
    return (
      <Row>
        <Col xs={12} md-offset={1} md={6} >
          <EarnedForWinning />
        </Col>
        <Col xs={12} md={4} >
          <SummaryMission />
        </Col>
      </Row>
    )
  }

}

MissionFinish.propTypes = {
  campaign: React.PropTypes.shape({
    id: React.PropTypes.number,
  }),
  selectCampaign: React.PropTypes.func,
}

const mapStateToProps = state => ({
  ...state.missions.selectedMission, campaign: state.campaigns.selectedCampaign,
})

const mapDispatchToProps = dispatch => ({
  selectCampaign: campaign => () => {
    dispatch(selectCampaign(campaign))
  },
})


export default connect(mapStateToProps, mapDispatchToProps)(MissionFinish)



// WEBPACK FOOTER //
// ./src/components/MissionFinish/index.jsx